export default "/images/e0441a23a50b1494c25ce8418f70b3d8.avif";